import {
  CAPKIT_APP_URL,
  CAPKIT_PACKAGE_ID,
  ROOCH_RPC_URL,
} from './network';

export const capKitConfig = {
  roochUrl: ROOCH_RPC_URL,
  appUrl: CAPKIT_APP_URL,
  contractAddress: CAPKIT_PACKAGE_ID,
};
